import { useStore } from '@lib/state-engine';
import { ChoiceGroup } from '@ui/choice-group';
import { $selectedViewMode, MODES, setViewMode, ViewMode } from './model';
import styles from './styles.module.css';

export const StorageModeSelect = () => {
  // Используем optional chaining для безопасного доступа к значению
  const value = useStore($selectedViewMode);
  return (
    <ChoiceGroup
      className={styles.selector}
      items={MODES}
      value={value ?? MODES[0]} // Установите значение по умолчанию
      onChange={(v) => setViewMode(v.value as ViewMode)}
    />
  );
};
